import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from 'reactstrap';
import { divisionActions } from '../_actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/fontawesome-free-solid'

class DeleteDivisionModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
    this.deleteDivision = this.deleteDivision.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  deleteDivision() {
    this.props.delete(this.props.division_id);
    this.toggle();
  }

  render() {
    return (
      <div>
        <Button color="danger" className="full-width" onClick={this.toggle}><FontAwesomeIcon icon={faTimes} color="white" size="lg" /></Button>
        <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
          <ModalHeader>Supprimer une division</ModalHeader>
          <ModalBody>
            <div>Voulez-vous supprimer une division?</div>
          </ModalBody>
          <ModalFooter>
            <Row>
              <Col>
                <Button color="danger" onClick={this.deleteDivision}>Supprimer</Button>
              </Col>
              <Col xs="6" className="text-center" >
                <Button color="secondary" onClick={this.toggle}>Annuler</Button>
              </Col>
            </Row>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {};
}

const mapDispatchToProps = (dispatch) => {
  return {
    delete: (division_id) => {
      dispatch(divisionActions.delete(division_id))
    }
  }
}

const connectedDeleteDivisionModal = connect(mapStateToProps, mapDispatchToProps)(DeleteDivisionModal);
export { connectedDeleteDivisionModal as DeleteDivisionModal };
